import React, { Component, Fragment } from 'react';
import { Route, Routes } from 'react-router-dom'
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { route } from "../routes";
import ListingsController from '../controllers/ListingsController';
import DetailsController from '../controllers/DetailsController';
import {GelContentContainer, NotFound} from "cw-styleguide-react";

class AnimalsView extends Component {
  render() {


      return (
      <Fragment>
        <BreadcrumbsItem to={route('animals')}>
          {this.props.t('route_animals_title')}
        </BreadcrumbsItem>
        <Routes>
          <Route
            index
            element={
              <ListingsController
                {...this.props}
                resetAnswers={this.props.resetAnswers}
              />
            }
          />
          <Route
            path={':id/:tab'}
            element={
              <DetailsController
                {...this.props}
                resetAnswers={this.props.resetAnswers}
              />
            }
          />
            <Route path="*" element={<GelContentContainer><NotFound/></GelContentContainer>} />

        </Routes>
      </Fragment>
    );
  }
}

export default AnimalsView;
